<template>
	
	<!-- Main Sidebar -->
	<a-layout-sider
		class="sider-primary"
		breakpoint="lg"
		collapsed-width="0"
		width="250px"
		:collapsed="sidebarCollapsed"
		@collapse="$emit('toggleSidebar', ! sidebarCollapsed)"
		:trigger="null"
		:class="['ant-layout-sider-' + sidebarColor, 'ant-layout-sider-' + sidebarTheme]"
		theme="light"
		:style="{ backgroundColor: 'transparent',}">
			<div class="brand" id="app-info">
                <img id="logo" src="/siakri/images/logo-ugm.png" alt="">
                <div id="app-name-container">
                    <div id="app-name">{{ appName }}</div>
                    <div id="app-rsgm">{{ appRsgm }}</div>
                </div>
            </div>

			<hr>

			<!-- Sidebar Navigation Menu -->
			<a-menu theme="light" mode="inline"
      			:open-keys="openKeys"
				@openChange="onOpenChange">
				<a-sub-menu key="dashboards" style="padding: 0;">
					<span slot="title">
						<span class="icon">
							<a-icon type="dashboard" theme="filled" class="m-0" />
						</span>
						<span class="label">Halaman</span>
					</span>
					<a-menu-item-group>
						<a-menu-item>
							<router-link to="/dashboards/">
								<span class="label">Dashboard</span>
							</router-link>
						</a-menu-item>

                        <!-- KOAS ============================= -->
						<a-menu-item v-if="$store.getters['auth/isUserKoas']">
							<router-link to="/dashboards/tindakan">
								<span class="label">History Tindakan</span>
							</router-link>
						</a-menu-item>

						<a-menu-item v-if="$store.getters['auth/isUserKoas']">
							<router-link to="/dashboards/history-format-kerja">
								<span class="label">History Format Kerja</span>
							</router-link>
						</a-menu-item>

                        <a-menu-item v-if="$store.getters['auth/isUserKoas']">
							<router-link to="/dashboards/billing">
								<span class="label">Billing</span>
							</router-link>
						</a-menu-item>

                        <a-menu-item v-if="$store.getters['auth/isUserKoas']">
                            <router-link to="/dashboards/history-booking">
                                <span class="label">History Booking</span>
                            </router-link>
                        </a-menu-item>

                        <!-- DPJP ============================= -->
                        <a-menu-item v-if="$store.getters['auth/isUserDokter']">
							<router-link to="/dashboards/billing-dpjp">
								<span class="label">Billing Koas</span>
							</router-link>
						</a-menu-item>

                        <!-- ADMIN ============================= -->
                        <a-menu-item v-if="$store.getters['auth/isUserAdmin']">
							<router-link to="/dashboards/management/koas">
								<span class="label">Koas</span>
							</router-link>
						</a-menu-item>

                        <a-menu-item v-if="$store.getters['auth/isUserAdmin']">
							<router-link to="/dashboards/management/dpjp">
								<span class="label">DPJP</span>
							</router-link>
						</a-menu-item>

                        <a-menu-item v-if="$store.getters['auth/isUserAdmin']">
							<router-link to="/dashboards/jadwal-dpjp">
								<span class="label">Jadwal DPJP</span>
							</router-link>
						</a-menu-item>

                        <a-menu-item v-if="$store.getters['auth/isUserAdmin']">
                            <router-link to="/dashboards/management/user">
                                <span class="label">User</span>
                            </router-link>
                        </a-menu-item>

                        <a-menu-item v-if="$store.getters['auth/isUserAdmin']">
                            <router-link to="/dashboards/management/klinik">
                                <span class="label">Klinik</span>
                            </router-link>
                        </a-menu-item>

                        <a-menu-item v-if="$store.getters['auth/isUserAdmin']">
                            <router-link to="/dashboards/evaluasi">
                                <span class="label">Evaluasi</span>
                            </router-link>
                        </a-menu-item>

                        <a-menu-item v-if="$store.getters['auth/isUserAdmin']">
                            <router-link to="/dashboards/history-format-kerja-admin">
                                <span class="label">History Format Kerja</span>
                            </router-link>
                        </a-menu-item>

                        <a-menu-item v-if="$store.getters['auth/isUserAdmin']">
                            <router-link to="/dashboards/billing-admin">
                                <span class="label">Billing Koas</span>
                            </router-link>
                        </a-menu-item>

                        <!-- DEV ============================= -->
                        <a-menu-item v-if="$store.getters['auth/isUserDev']">
                            <router-link to="/dashboards/dbcompare">
                                <span class="label">DB Structure Compare</span>
                            </router-link>
                        </a-menu-item>
                        <a-menu-item v-if="$store.getters['auth/isUserDev']">
                            <router-link to="/dashboards/dbcopy">
                                <span class="label">DB Copy Data</span>
                            </router-link>
                        </a-menu-item>
					</a-menu-item-group>
				</a-sub-menu>
			</a-menu>
			<!-- / Sidebar Navigation Menu -->


	</a-layout-sider>
	<!-- / Main Sidebar -->

</template>

<script>

import {APP_NAME, APP_NAME_SHORT, APP_RSGM} from "../../utils/Config";

export default ({
    props: {
        // Sidebar collapsed status.
        sidebarCollapsed: {
            type: Boolean,
            default: false,
        },

        // Main sidebar color.
        sidebarColor: {
            type: String,
            default: "primary",
        },

        // Main sidebar theme : light, white, dark.
        sidebarTheme: {
            type: String,
            default: "light",
        },
    },

    data() {
        return {
            rootSubmenuKeys: ['dashboards', 'pages', 'applications', 'ecommerce', 'authentication', 'basic', 'components', 'changelog'],
            openKeys: this.$route.meta.sidebarMap,
        }
    },

    methods: {
        onOpenChange(openKeys)
        {
            const latestOpenKey = openKeys.find( key => this.openKeys.indexOf( key ) === -1) ;

            if ( this.rootSubmenuKeys.indexOf( latestOpenKey ) === -1 )
            {
                this.openKeys = openKeys;
            }
            else
            {
                this.openKeys = latestOpenKey ? [ latestOpenKey ] : [] ;
            }
        },
    },

    computed: {
        appName() {
            return APP_NAME_SHORT
        },

        appRsgm() {
            return APP_RSGM
        }
    },
})

</script>

<style scoped>

#app-info {
    display: flex;
    align-items: start;
    padding: 0;
}

#logo {
    width: 40px;
    margin-top: 5px;
}

#app-name-container {
    margin-left: 7px;
}

#app-name {
    font-size: 20px;
    font-weight: bold;
}

#app-rsgm {
    font-size: 13px;
}

</style>